var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "q-page-header" }, [
    _c("h3", { staticClass: "ng-scope" }, [
      _vm._v("\n    " + _vm._s(_vm.caption) + "\n    "),
      _c("small", [_vm._v(_vm._s(_vm.note))]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }